require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.is-array");

module.exports = {
  isArray: function isArray(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    } // fallback for older browsers like  IE 8


    return Object.prototype.toString.call(value) === '[object Array]';
  }
};